import React, { lazy, Suspense, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import AOS from 'aos';
import 'aos/dist/aos.css';

import Logo from './images/logo.png'

import Layout from './layouts/defaultLayout/Layout';
import Dashboard from './layouts/dashboardLayout/Dashboard';

import PrivateRoute from './utils/PrivateRoute';
import PublicRoute from './utils/PublicRoute';

const Home = lazy(() => import('./pages/default/Home'));
const About = lazy(() => import('./pages/default/About'));
const Services = lazy(() => import('./pages/default/Services'));
const Production = lazy(() => import('./pages/default/Production'));
const Realization = lazy(() => import('./pages/default/Realization'));
const Contact = lazy(() => import('./pages/default/Contact'));



const App = () => {
  const { i18n } = useTranslation();


  useEffect(() => {
    AOS.init();
  }, [])

  return (
    <Suspense fallback={<div className='h-screen w-full flex justify-center items-center'>
      <img src={Logo} className='h-16' />
    </div>}>
      <Routes>
        <Route element={<PublicRoute />}>
          <Route path="/" element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/production" element={<Production />} />
            <Route path="/realizations" element={<Realization />} />
            <Route path="/contact" element={<Contact />} />
          </Route>
        </Route>
      </Routes>
    </Suspense>
  );
};

export default App;
